import Vue from 'vue'

const VueMobileDetection = () => import("vue-mobile-detection");

Vue.use(VueMobileDetection)